




















































import { defineComponent, ref, watch, toRef, onUnmounted, computed } from "@vue/composition-api";
import { LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import useOrientation from "@/hooks/useOrientation";
import { parseISO, toTimePassed, differenceInMilliseconds } from "@/lib/time";
import { connectionStateEnum } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseVideo from "@/components/BaseVideo";
import MobileSwitchCam from "@/components/MobileSwitchCam";
import Share from "@/components/Share";
import StreamChat from "../StreamChat";

export default defineComponent({
  name: "StreamView",
  components: { BaseVideo, BaseButton, BaseIcon, StreamChat, MobileSwitchCam, Share },
  props: {
    produce: { type: Boolean, required: true },
    stream: { type: MediaStream, required: true },
    connecting: { type: Boolean, required: true },
    connectingState: { type: String, required: true },
    loading: { type: Boolean, required: true },
    userList: { type: Array as () => LiveChatUser[], required: true },
    streamStartedDate: { type: String, required: true },
    threadId: { type: String },
    token: { type: String },
  },
  setup(props, { emit }) {
    const showTime = ref(true);
    const showEnding = ref(false);
    const timePassed = ref("");
    const { isLandscape } = useOrientation();

    const timeClick = () => (showTime.value = !showTime.value);

    const overlayClass = computed(() => ({
      __background: showEnding.value || props.loading || props.connecting,
    }));

    const onClose = () => emit("close");
    const endClick = () => {
      if (props.produce) {
        showEnding.value = !showEnding.value;
      } else {
        onClose();
      }
    };

    let interval: ReturnType<typeof setInterval>;
    watch(toRef(props, "streamStartedDate"), streamStartedDate => {
      interval && clearInterval(interval);
      if (!streamStartedDate) {
        timePassed.value = "";
        return;
      }
      const countDate = () => {
        timePassed.value = toTimePassed(
          Math.max(0, differenceInMilliseconds(new Date(), parseISO(props.streamStartedDate)))
        );
      };
      countDate();
      interval = setInterval(countDate, 1000);
    });
    onUnmounted(() => interval && clearInterval(interval));

    const showChat = computed(
      () => !showEnding.value && !props.connecting && !props.loading && !!props.threadId && !!props.token
    );

    const mirrorVideo = computed(() => {
      const tracks = props.stream.getVideoTracks();
      const settings = tracks.length > 0 && props.stream.getVideoTracks()[0].getSettings();
      return props.produce && (!settings || !settings.facingMode || settings.facingMode === "user");
    });

    return {
      showTime,
      showEnding,
      timePassed,
      timeClick,
      endClick,
      onClose,
      overlayClass,
      showChat,
      isLandscape,
      mirrorVideo,
      connectionStateEnum,
    };
  },
});
